(function(){
  var d = document, busy = false;

  function money(c){ return '₹' + Math.round(c / 100).toLocaleString('en-IN'); }

  function closeModal(){
    var m = d.getElementById('rsQaModal');
    if (m) { m.remove(); }
    d.removeEventListener('keydown', onKey);
  }
  function onKey(e){ if (e.key === 'Escape') { closeModal(); } }

  function addToCart(id, btn, errEl){
    if (btn) { btn.classList.add('is-loading'); }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function(r){ return r.json().then(function(j){ return { ok: r.ok, j: j }; }); })
    .then(function(res){
      if (btn) { btn.classList.remove('is-loading'); }
      if (!res.ok) {
        var msg = (res.j && (res.j.description || res.j.message)) || 'Could not add this item. Please try again.';
        if (errEl) { errEl.textContent = msg; } else { alert(msg); }
        return;
      }
      closeModal();
      d.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }).catch(function(){
      if (btn) { btn.classList.remove('is-loading'); }
      if (errEl) { errEl.textContent = 'Network error. Please try again.'; }
    });
  }

  function openModal(p){
    closeModal();
    var variants = p.variants;
    var sel = variants.filter(function(v){ return v.available; })[0];
    var wrap = d.createElement('div');
    wrap.id = 'rsQaModal'; wrap.className = 'rs-qam';
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true');
    var box = d.createElement('div'); box.className = 'rs-qam__box';
    var x = d.createElement('button'); x.type = 'button'; x.className = 'rs-qam__x'; x.setAttribute('aria-label', 'Close'); x.textContent = '×';
    var head = d.createElement('div'); head.className = 'rs-qam__head';
    if (p.featured_image) {
      var im = d.createElement('img'); im.src = p.featured_image; im.alt = ''; head.appendChild(im);
    }
    var info = d.createElement('div');
    var tt = d.createElement('div'); tt.className = 'rs-qam__title'; tt.textContent = p.title;
    var pr = d.createElement('div'); pr.className = 'rs-qam__price'; pr.textContent = money(sel.price);
    info.appendChild(tt); info.appendChild(pr); head.appendChild(info);
    var lbl = d.createElement('p'); lbl.className = 'rs-qam__lbl'; lbl.textContent = 'Choose option';
    var opts = d.createElement('div'); opts.className = 'rs-qam__opts';
    var err = d.createElement('p'); err.className = 'rs-qam__err';
    var add = d.createElement('button'); add.type = 'button'; add.className = 'rs-qam__add'; add.textContent = 'Add to cart';

    variants.forEach(function(v){
      var b = d.createElement('button'); b.type = 'button'; b.className = 'rs-qam__opt';
      b.textContent = v.title; if (!v.available) { b.disabled = true; }
      if (v.id === sel.id) { b.classList.add('is-sel'); }
      b.addEventListener('click', function(){
        sel = v; err.textContent = '';
        opts.querySelectorAll('.rs-qam__opt').forEach(function(o){ o.classList.remove('is-sel'); });
        b.classList.add('is-sel'); pr.textContent = money(v.price);
      });
      opts.appendChild(b);
    });

    add.addEventListener('click', function(){ addToCart(sel.id, add, err); });
    x.addEventListener('click', closeModal);
    wrap.addEventListener('click', function(e){ if (e.target === wrap) { closeModal(); } });
    d.addEventListener('keydown', onKey);

    box.appendChild(x); box.appendChild(head); box.appendChild(lbl); box.appendChild(opts); box.appendChild(err); box.appendChild(add);
    wrap.appendChild(box); d.body.appendChild(wrap);
    add.focus();
  }

  d.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.rs-qa');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    if (busy) return;
    var handle = b.getAttribute('data-handle');
    if (!handle) return;
    busy = true; b.classList.add('is-loading');
    fetch('/products/' + encodeURIComponent(handle) + '.js').then(function(r){ return r.json(); }).then(function(p){
      busy = false; b.classList.remove('is-loading');
      var avail = p.variants.filter(function(v){ return v.available; });
      if (!avail.length) return;
      if (p.variants.length === 1) { addToCart(avail[0].id, null, null); } else { openModal(p); }
    }).catch(function(){ busy = false; b.classList.remove('is-loading'); });
  }, true);
})();
